import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField } from "@mui/material";
import "./style.css";
import { TimePicker } from "@mui/x-date-pickers";

export default function BaseDatePicker({
  defaultValue,
  slotProps,
  type,
  error,
  helperText,
  disabled,
  isCustomStyle = false,
  readOnly = true,
  ...props
}) {
  const disabledStyle = {
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor: "#f5f5f5", // ✅ grey background
      // borderRadius: "8px",
      cursor: "not-allowed",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "#9f9f9fff", // ✅ grey text
    },
    // ✅ grey calendar icon so the field reads as disabled at a glance
    "& .MuiIconButton-root.Mui-disabled": {
      color: "#bdbdbd",
      backgroundColor: "transparent !important",
      cursor: "not-allowed",
    },
  };

  const datePickerStyles = {
    "& .MuiOutlinedInput-root": {
      height: "42px",
      borderRadius: "8px",
      backgroundColor: "white",
      boxShadow: "1px 1px 4px 1px #29292921",
      display: "flex",
      alignItems: "center",
      margin: "6px 1.5px",
      border: "1px solid #D9D9D9 !important",
      padding: "0 !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
      boxShadow: "none",
    },
    "& .MuiInputBase-input": {
      padding: "4px 12px",
      fontSize: "13px",
      height: "18px",
      lineHeight: "1.4",
      color: "#555",
    },
    "& .MuiInputAdornment-root": {
      marginLeft: "0",
    },
    "& .MuiIconButton-root": {
      padding: "4px 8px",
      backgroundColor: "transparent !important",
      border: "none !important",
    },
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer
        components={["TimePicker", "DateTimePicker", "TimeRangePicker", "DateTimeRangePicker"]}
      >
        {type === "date" && (
          <div className="w-full">
            <DatePicker
              {...props}
              disabled={disabled}
              slots={{
                openPickerIcon: () => (
                  <i className="fa-light fa-calendar-days" style={{ fontSize: "20px" }} />
                ),
              }}
              slotProps={{
                ...slotProps,
                textField: {
                  fullWidth: true,
                  inputProps: { readOnly },
                  ...(slotProps?.textField || {}),
                  sx: {
                    ...(isCustomStyle ? datePickerStyles : {}),
                    ...(slotProps?.textField?.sx || {}),
                    // Applied last so a disabled field always looks disabled,
                    // whatever styling the caller passes in.
                    ...(disabled ? disabledStyle : {}),
                  },
                },
              }}
              renderInput={(params) => (
                <TextField label="MM/DD/YYYY" {...params} error={true} helperText="Hi" />
              )}
            />
            <div className="flex justify-between">
              {error && <p className="text-[#d32f2f] w-full  text-xs">{helperText}</p>}
            </div>
          </div>
        )}
        {type === "time" && (
          <TimePicker
            {...props}
            minutesStep={props.minutesStep ?? 1}
            timeSteps={{ hours: 1, minutes: 1 }}
            disabled={disabled}
            defaultValue={defaultValue}
            closeOnSelect={false}
            slotProps={{
              textField: {
                inputProps: { readOnly },
                disabled,
                sx: disabledStyle,
              },
            }}
            /* renderInput={(params) => (
              <TextField label="MM/DD/YYYY" {...params} />
            )} */
          />
        )}
      </DemoContainer>
    </LocalizationProvider>
  );
}
